/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AggregatesListingMeQueryVariables = {||};
export type AggregatesListingMeQueryResponse = {|
  +me: ?{|
    +isAdmin: ?boolean,
    +isBroker: ?boolean,
  |}
|};
export type AggregatesListingMeQuery = {|
  variables: AggregatesListingMeQueryVariables,
  response: AggregatesListingMeQueryResponse,
|};
*/


/*
query AggregatesListingMeQuery {
  me {
    isAdmin
    isBroker
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBroker",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AggregatesListingMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c03a49e97ce7eb5173a1725ff4c487cf",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingMeQuery",
    "operationKind": "query",
    "text": "query AggregatesListingMeQuery {\n  me {\n    isAdmin\n    isBroker\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf2fdd21347825ab52d4c5a2a8113f3d';

export default node;
